export default __webpack_public_path__ + "static/media/go.4a952fa5.svg";